import React, { Component } from "react";

import "./MainPage.css";
import LogoMain from "../../components/LogoMain/LogoMain";

class MainPage extends Component {
  state = {
    architectureShow: false,
    cloackroomShow: false
  };
  onMouseEnterHandlerArchitecture = event => {
    this.setState({
      architectureShow: true,
      cloackroomShow: false
    });
  };
  onMouseLeaveHandlerArchitecture = event => {
    this.setState({
      architectureShow: false,
      cloackroomShow: false
    });
  };
  onMouseEnterHandlerCloackroom = event => {
    this.setState({
      architectureShow: false,
      cloackroomShow: true
    });
  };
  onMouseLeaveHandlerCloackroom = event => {
    this.setState({
      architectureShow: false,
      cloackroomShow: false
    });
  };

  render() {
    let architectureHover = this.state.architectureShow ? (
      <div className="hoverTile architectureHover vertical-align">
        <div>
          <p className="p-5">Architektura i budownictwo</p>
          <small>…spełniaj marzenia…</small>
        </div>
      </div>
    ) : null;
    let cloackroomHover = this.state.cloackroomShow ? (
      <div className="hoverTile cloackroomHover vertical-align">
        <div>
          <p className="p-5">Szatnia samoobsługowa</p>
          <small>…uporządkuj sprawy…</small>
        </div>
      </div>
    ) : null;

    return (
      <div id="choice-menu">
        <div className="container">
          <div className="row justify-content-center logoRow">
            <div className="col-8 col-sm-6 col-md-2">
              <LogoMain />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-6 col-xl-4 text-center justify-content-center my-3">
              <a href="/architektura_i_budownictwo">
                <div
                  className="tile architecture vertical-align"
                  onMouseEnter={this.onMouseEnterHandlerArchitecture}
                  onMouseLeave={this.onMouseLeaveHandlerArchitecture}
                >
                  {architectureHover}
                </div>
              </a>
            </div>
            <div className="col-sm-10 col-md-6 col-xl-4 text-center justify-content-center my-3">
              <a href="/szatnia_samoobslugowa">
                <div
                  className="tile cloackroom vertical-align"
                  onMouseEnter={this.onMouseEnterHandlerCloackroom}
                  onMouseLeave={this.onMouseLeaveHandlerCloackroom}
                >
                  {cloackroomHover}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/containers/MainPage/MainPage.js